import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

export const Container = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing.large,
    gap: theme.spacing.medium,
    alignItems: "stretch",
    paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.large})`,
}));

export const Header = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: theme.spacing.medium,
}));

export const PaymentAmountText = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Med_Emphasis,
}));

export const IconAndTitleContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing.small,
    marginBottom: theme.spacing.medium,
    width: "100%",
}));

export const TitleContainer = styled.div({
    flex: 1,
    display: "flex",
    alignItems: "center",
});

export const TextContainer = styled.div(({ theme }) => ({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: theme.spacing.small,
}));

export const DescriptionContainer = styled.div(() => ({
    width: "100%",
}));

export const ButtonContainer = styled.div({
    width: "100%",
    marginTop: "auto",
});
